module.exports = __webpack_public_path__ + "static/img/13.66db25f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity20250403/13.png
// module id = LZEL
// module chunks = 0